import { render } from "./DettaglioModal.vue?vue&type=template&id=83a7e5ae"
import script from "./DettaglioModal.vue?vue&type=script&lang=js"
export * from "./DettaglioModal.vue?vue&type=script&lang=js"

import "./DettaglioModal.vue?vue&type=style&index=0&id=83a7e5ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__